export default {
    host: process.env.YLP_API_HOST || 'http://localhost:8000',
    timeoutMs: 5000,
};
